/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import {CustomAppEvent, Loader, WithEvents} from '@dvrd/dvr-controls';

import React, {PureComponent} from 'react';

interface State {
    loading: boolean;
}

export default class GlobalLoader extends PureComponent<any, State> {
    private readonly event: CustomAppEvent;

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false
        };
        this.event = {eventName: 'onGlobalLoad', handler: this.onLoad};
    }

    private onLoad = (load: boolean) => {
        this.setState({loading: load});
    };

    render = () => {
        return (
            <WithEvents events={this.event}>
                <Loader active={this.state.loading} />
            </WithEvents>
        );
    };
}
